import { render, staticRenderFns } from "./AntTable.vue?vue&type=template&id=bf8e7d64&"
import script from "./AntTable.vue?vue&type=script&lang=js&"
export * from "./AntTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports